import { useState } from "react";

import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

const PhonepeProcess = () => {
  const [isPrevDisabled, setIsPrevDisabled] = useState(true);
  const [isNextDisabled, setIsNextDisabled] = useState(false);

  const handleSlide = (processSwiper) => {
    setIsPrevDisabled(processSwiper.isBeginning);
    setIsNextDisabled(processSwiper.isEnd);
  };

  return (
    <div>
      {" "}
      <div className="why-custom-swiper">
        <Swiper
          spaceBetween={20}
          slidesPerView={4}
          modules={[Navigation, A11y]}
          navigation={{
            prevEl: ".ph-process-prev-btn",
            nextEl: ".ph-process-next-btn",
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            480: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1025: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          }}
          onSlideChange={handleSlide}
          onReachBeginning={() => setIsPrevDisabled(true)}
          onReachEnd={() => setIsNextDisabled(true)}
          onFromEdge={() => {
            setIsPrevDisabled(false);
            setIsNextDisabled(false);
          }}
        >
          <SwiperSlide>
            <div className="ph-process-cards">
              <h6>01</h6>
              <h4>Planning and Requirement Gathering</h4>
              <ul className="ph-process-lists">
                <li>Define the target audience and business objectives.</li>
                <li>
                  Outline the core features and functionalities of the PhonePe
                  clone app.
                </li>
              </ul>

              <div className="ph-process-circle one">
                <div className="ph-process-circle-inner"></div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="ph-process-cards">
              <h6>02</h6>
              <h4>UI/UX Design</h4>
              <ul className="ph-process-lists">
                <li>
                  Create wireframes and prototypes to visualize the app’s
                  design.
                </li>
                <li>
                  Focus on creating a user-friendly and aesthetically pleasing
                  interface.
                </li>
              </ul>

              <div className="ph-process-circle two">
                <div className="ph-process-circle-inner"></div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="ph-process-cards">
              <h6>03</h6>
              <h4>Backend and Frontend Development</h4>
              <ul className="ph-process-lists">
                <li>
                  Develop the app’s core functionality using the chosen
                  technology stack.
                </li>
                <li>
                  Make Sure hasslefree integration between the backend &
                  frontend.
                </li>
              </ul>

              <div className="ph-process-circle three">
                <div className="ph-process-circle-inner"></div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="ph-process-cards">
              <h6>04</h6>
              <h4>Testing and Quality Assurance</h4>
              <ul className="ph-process-lists">
                <li>Perform thorough testing to detect and resolve bugs.</li>
                <li>
                  Verify the app's performance across different scenarios.
                </li>
              </ul>

              <div className="ph-process-circle one">
                <div className="ph-process-circle-inner"></div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="ph-process-cards">
              <h6>05</h6>
              <h4>Deployment and Maintenance</h4>
              <ul className="ph-process-lists">
                <li>Launch the app on app stores and web platforms.</li>
                <li>
                  Provide ongoing support and updates to improve performance and
                  security.
                </li>
              </ul>

              <div className="ph-process-circle two">
                <div className="ph-process-circle-inner"></div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>

        <div className="why-custom-btn-wrapper st-key-btn-wrapper ph-swiper-btn-wrap">
          <button
            className={`ph-process-prev-btn  ph-left-btn ${
              isPrevDisabled ? "disabled" : ""
            }`}
            style={{
              color: isPrevDisabled ? "#6E6F70" : "#0f0f0f",
              cursor: isPrevDisabled ? "not-allowed" : "pointer",
            }}
          >
            <i className="fa-solid fa-arrow-left"></i>
          </button>
          <button
            className={`ph-process-next-btn  ph-right-btn ${
              isNextDisabled ? "disabled" : ""
            }`}
            style={{
              color: isNextDisabled ? "#6E6F70" : "#0f0f0f",
              cursor: isNextDisabled ? "not-allowed" : "pointer",
            }}
          >
            <i className="fa-solid fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhonepeProcess;
